// Miroir frontend de backend/config/contractTypes.js (slugs + fallback FR).
// Aligné : slugs identiques, ordre identique. Labels EN/ES via i18n
// (forms:experience.contract_type.<slug>), fallback FR sinon.
//
// Si tu ajoutes/retires un type, propage dans backend/config/contractTypes.js
// (pas de migration : colonne VARCHAR validée par isValidContractType).

export const CONTRACT_TYPE_VALUES = [
  'permanent',
  'fixed_term',
  'apprenticeship',
  'internship',
  'temporary',
  'contractor',
  'self_employed',
  'public_sector',
  'volunteer',
  'other',
]

export const CONTRACT_TYPE_LABELS = {
  permanent: 'CDI',
  fixed_term: 'CDD',
  apprenticeship: 'Alternance',
  internship: 'Stage',
  temporary: 'Intérim',
  contractor: 'Freelance / prestataire',
  self_employed: 'Indépendant',
  public_sector: 'Secteur public',
  volunteer: 'Bénévolat',
  other: 'Autre',
}

// Label affichable. Avec `t` → i18n (fallback FR) ; sans `t` → map FR.
// Slug inconnu/ancien → retourne le slug (visible et diagnosticable, jamais vide).
export const getContractTypeLabel = (slug, t) => {
  if (!slug) return ''
  if (t) return t(`forms:experience.contract_type.${slug}`, { defaultValue: CONTRACT_TYPE_LABELS[slug] || slug })
  return CONTRACT_TYPE_LABELS[slug] || slug
}

export const isValidContractType = (value) =>
  value === null || value === undefined || value === '' || CONTRACT_TYPE_VALUES.includes(value)
